/**
 * CuidaDF - Componente principal da aplicacao
 *
 * Controla a navegacao entre as telas: Splash -> Home -> Triagem -> Resultado
 *
 * Autora: Izabella Kristinne Dias Porto
 * Titular: I.P Tecnologia (ME)
 * Versao: 1.0
 */

import React, { useState } from "react";
import Splash from "./components/Splash";
import Home from "./components/Home";
import Triagem from "./components/Triagem";
import Resultado from "./components/Resultado";
import "./styles/App.css";

const TELAS = {
  SPLASH: "splash",
  HOME: "home",
  TRIAGEM: "triagem",
  RESULTADO: "resultado",
};

function App() {
  const [telaAtual, setTelaAtual] = useState(TELAS.SPLASH);
  const [resultadoTriagem, setResultadoTriagem] = useState(null);

  function irParaHome() {
    setTelaAtual(TELAS.HOME);
  }

  function irParaTriagem() {
    setTelaAtual(TELAS.TRIAGEM);
  }

  function finalizarTriagem(resultado) {
    setResultadoTriagem(resultado);
    setTelaAtual(TELAS.RESULTADO);
  }

  function voltarParaHome() {
    setResultadoTriagem(null);
    setTelaAtual(TELAS.HOME);
  }

  return (
    <div className="app-container">
      {telaAtual === TELAS.SPLASH && (
        <Splash onComecar={irParaHome} />
      )}

      {telaAtual === TELAS.HOME && (
        <Home onIniciarTriagem={irParaTriagem} />
      )}

      {telaAtual === TELAS.TRIAGEM && (
        <Triagem
          onVoltar={voltarParaHome}
          onConcluir={finalizarTriagem}
        />
      )}

      {telaAtual === TELAS.RESULTADO && resultadoTriagem && (
        <Resultado
          resultado={resultadoTriagem}
          onNovaTriagem={voltarParaHome}
        />
      )}
    </div>
  );
}

export default App;
